import { rem } from 'polished';
import React from 'react';
import { Loader } from '@unmind/design-system';
import styled, { useTheme } from 'styled-components';
import { ScreenReaderContent } from '../Accessibility';
import { ID_LOADING } from '../LoadingIndicator';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${rem(52)};
`;

export const MediaLoadingIndicator = ({
  isAudioPlayer,
}: {
  isAudioPlayer?: boolean;
}) => {
  const theme = useTheme();

  return (
    <Container data-testid={ID_LOADING}>
      <Loader
        color={
          isAudioPlayer
            ? theme.colors.mediaPlayer.audio.icon.default
            : theme.colors.staticPalette.white
        }
      />
      <ScreenReaderContent as="span">Loading</ScreenReaderContent>
    </Container>
  );
};
